import { t } from '@lingui/core/macro';
import { ReferralJourneyStatus } from '@navio/nsdk';
import { filterByReferralStaffTab, toReferralStaffStatus, type ReferralStaffStatusTab } from 'noddi-web';

export type ReferredFriendsTab = ReferralStaffStatusTab;

export type CustomerReferralBadgeVariant = 'success' | 'warning' | 'outline';

export const customerReferralStatusBadgeVariant = (status: ReferralJourneyStatus): CustomerReferralBadgeVariant => {
  const staffStatus = toReferralStaffStatus(status);
  if (staffStatus === 'successful') {
    return 'success';
  }
  if (staffStatus === 'expired') {
    return 'outline';
  }
  return 'warning';
};

export const filterReferredFriendsByTab = <T extends { status: ReferralJourneyStatus }>(
  friends: T[],
  tab: ReferredFriendsTab
): T[] => filterByReferralStaffTab(friends, tab);

export const referralFriendStatusSubtext = (status: ReferralJourneyStatus): string => {
  if (status === ReferralJourneyStatus.REDEEMED) {
    return t`Used their reward`;
  }
  if (status === ReferralJourneyStatus.EARNED) {
    return t`Completed their booking`;
  }
  if (status === ReferralJourneyStatus.EXPIRED) {
    return t`Invite expired`;
  }
  return t`Waiting for order`;
};
